/*jshint esversion: 6 */
/*jshint strict: false */

import $ from 'jquery';

const serviceUrls = {
    facebook: 'https://www.facebook.com/sharer/sharer.php?u={url}',
    twitter: 'https://twitter.com/intent/tweet?url={url}&text={title}',
    linkedin: 'https://www.linkedin.com/shareArticle?url={url}',
    googleplus: 'https://plus.google.com/share?url={url}',
};

function init() {
    $('div[data-service]').each(function() {
        $(this).on('click', function() {
            if( $(this).attr('data-service') !== 'embed' ) {
                var url = serviceUrls[$(this).attr('data-service')];
                url = url.replace(/{url}/, encodeURI(window.location.href));
                url = url.replace(/{title}/, encodeURIComponent(document.title));
                window.open(url, 'share', 'width=600,height=500,toolbar=0,personalbar=0');
            } else {
                $('.embed').slideDown();
            }
        })
    });

    $('.embed .close').on('click', function() {
        $('.embed').slideUp();
    })
}

export {init}


// WEBPACK FOOTER //
// ./social.js